import React, { useCallback, type ChangeEvent } from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { useIntl } from '@atlassian/jira-intl';
import type { ColumnState } from '../../../../common/types';
import { useMappingState } from '../../../../controllers/import-state';
import messages from './messages';

export type Props = {
	fieldMap: ColumnState;
};

export const IncludeInImport = ({ fieldMap }: Props) => {
	const [, { setIsIncludedForColumn }] = useMappingState();
	const { formatMessage } = useIntl();

	const onChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			setIsIncludedForColumn(fieldMap.columnName, event.target.checked);
		},
		[fieldMap.columnName, setIsIncludedForColumn],
	);

	return (
		<Checkbox
			isChecked={fieldMap.isIncluded}
			onChange={onChange}
			size="large"
			aria-label={formatMessage(messages.checkboxAriaLabelNonFinal, {
				fieldName: fieldMap.columnName,
			})}
			testId="project-create-importer-upload-flow.ui.mapping-screen.field-mapping.include-in-import.checkbox"
		/>
	);
};
